export const DEMO = 'DEMEO'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CHANNEL_INFO = 'SET_CHANNEL_INFO'
export const SET_VERTIFY_STATE = 'SET_VERTIFY_STATE'
export const SET_API_LIST = 'SET_API_LIST'
